// @generated by protobuf-ts 2.9.4 with parameter optimize_code_size,long_type_number,generate_dependencies
// @generated from protobuf file "Protos/placements.proto" (package "wuxiaworld.api.v2", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { StringValue } from "../google/protobuf/wrappers";
import { SeriesTypeItem } from "./series_types";
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetPlacementsRequest
 */
export interface GetPlacementsRequest {
    /**
     * @generated from protobuf field: string page = 1;
     */
    page: string;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetPlacementsResponse
 */
export interface GetPlacementsResponse {
    /**
     * @generated from protobuf field: repeated wuxiaworld.api.v2.PlacementItem items = 1;
     */
    items: PlacementItem[];
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetPlacementEntriesRequest
 */
export interface GetPlacementEntriesRequest {
    /**
     * @generated from protobuf field: int32 placementId = 1;
     */
    placementId: number;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetPlacementEntriesResponse
 */
export interface GetPlacementEntriesResponse {
    /**
     * @generated from protobuf field: repeated wuxiaworld.api.v2.PlacementEntryItem items = 1;
     */
    items: PlacementEntryItem[];
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.PlacementEntryItem
 */
export interface PlacementEntryItem {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: int32 order = 2;
     */
    order: number;
    /**
     * @generated from protobuf field: string entryType = 3;
     */
    entryType: string;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.SeriesTypeItem series = 4;
     */
    series?: SeriesTypeItem;
    /**
     * @generated from protobuf oneof: innerEntry
     */
    innerEntry: {
        oneofKind: "card";
        /**
         * @generated from protobuf field: wuxiaworld.api.v2.CardPlacementEntryItem card = 5;
         */
        card: CardPlacementEntryItem;
    } | {
        oneofKind: "slider";
        /**
         * @generated from protobuf field: wuxiaworld.api.v2.SliderPlacementEntryItem slider = 6;
         */
        slider: SliderPlacementEntryItem;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.CardPlacementEntryItem
 */
export interface CardPlacementEntryItem {
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.BannerItem banner = 1;
     */
    banner?: BannerItem;
    /**
     * @generated from protobuf field: google.protobuf.StringValue characterImageUrl = 2;
     */
    characterImageUrl?: StringValue;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.SliderPlacementEntryItem
 */
export interface SliderPlacementEntryItem {
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.BannerItem
 */
export interface BannerItem {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string colorCode = 2;
     */
    colorCode: string;
    /**
     * @generated from protobuf field: string imageUrl = 3;
     */
    imageUrl: string;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.PlacementItem
 */
export interface PlacementItem {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.PlacementType type = 2;
     */
    type: PlacementType;
    /**
     * @generated from protobuf field: string title = 3;
     */
    title: string;
    /**
     * @generated from protobuf field: string page = 4;
     */
    page: string;
    /**
     * @generated from protobuf field: int32 order = 5;
     */
    order: number;
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.PlacementType
 */
export enum PlacementType {
    /**
     * @generated from protobuf enum value: Card = 0;
     */
    Card = 0,
    /**
     * @generated from protobuf enum value: Slider = 1;
     */
    Slider = 1
}
// @generated message type with reflection information, may provide speed optimized methods
class GetPlacementsRequest$Type extends MessageType<GetPlacementsRequest> {
    constructor() {
        super("wuxiaworld.api.v2.GetPlacementsRequest", [
            { no: 1, name: "page", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetPlacementsRequest
 */
export const GetPlacementsRequest = new GetPlacementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPlacementsResponse$Type extends MessageType<GetPlacementsResponse> {
    constructor() {
        super("wuxiaworld.api.v2.GetPlacementsResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PlacementItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetPlacementsResponse
 */
export const GetPlacementsResponse = new GetPlacementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPlacementEntriesRequest$Type extends MessageType<GetPlacementEntriesRequest> {
    constructor() {
        super("wuxiaworld.api.v2.GetPlacementEntriesRequest", [
            { no: 1, name: "placementId", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetPlacementEntriesRequest
 */
export const GetPlacementEntriesRequest = new GetPlacementEntriesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPlacementEntriesResponse$Type extends MessageType<GetPlacementEntriesResponse> {
    constructor() {
        super("wuxiaworld.api.v2.GetPlacementEntriesResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PlacementEntryItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetPlacementEntriesResponse
 */
export const GetPlacementEntriesResponse = new GetPlacementEntriesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlacementEntryItem$Type extends MessageType<PlacementEntryItem> {
    constructor() {
        super("wuxiaworld.api.v2.PlacementEntryItem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "entryType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "series", kind: "message", T: () => SeriesTypeItem },
            { no: 5, name: "card", kind: "message", oneof: "innerEntry", T: () => CardPlacementEntryItem },
            { no: 6, name: "slider", kind: "message", oneof: "innerEntry", T: () => SliderPlacementEntryItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.PlacementEntryItem
 */
export const PlacementEntryItem = new PlacementEntryItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CardPlacementEntryItem$Type extends MessageType<CardPlacementEntryItem> {
    constructor() {
        super("wuxiaworld.api.v2.CardPlacementEntryItem", [
            { no: 1, name: "banner", kind: "message", T: () => BannerItem },
            { no: 2, name: "characterImageUrl", kind: "message", T: () => StringValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.CardPlacementEntryItem
 */
export const CardPlacementEntryItem = new CardPlacementEntryItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SliderPlacementEntryItem$Type extends MessageType<SliderPlacementEntryItem> {
    constructor() {
        super("wuxiaworld.api.v2.SliderPlacementEntryItem", []);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.SliderPlacementEntryItem
 */
export const SliderPlacementEntryItem = new SliderPlacementEntryItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BannerItem$Type extends MessageType<BannerItem> {
    constructor() {
        super("wuxiaworld.api.v2.BannerItem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "colorCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "imageUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.BannerItem
 */
export const BannerItem = new BannerItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlacementItem$Type extends MessageType<PlacementItem> {
    constructor() {
        super("wuxiaworld.api.v2.PlacementItem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["wuxiaworld.api.v2.PlacementType", PlacementType] },
            { no: 3, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "page", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "order", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.PlacementItem
 */
export const PlacementItem = new PlacementItem$Type();
/**
 * @generated ServiceType for protobuf service wuxiaworld.api.v2.Placements
 */
export const Placements = new ServiceType("wuxiaworld.api.v2.Placements", [
    { name: "GetPlacements", options: {}, I: GetPlacementsRequest, O: GetPlacementsResponse },
    { name: "GetPlacementEntries", options: {}, I: GetPlacementEntriesRequest, O: GetPlacementEntriesResponse }
]);
